import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { useOccurenceLocationChartsDataContext } from './hooks/useOccurenceLocationChartsDataContext';
import L from 'leaflet';
import { number } from '../../../Common/Util/number';
import TableComponent from '../../../Common/Charts/TableCharts';

const CityServices = ({ queryConfig }) => {
    const { chartData } = useOccurenceLocationChartsDataContext(queryConfig);

    const center = [-15.7801, -47.9292];

    const tableColumns = [
        {
            key: 'description',
            header: 'Unidade',
            headerStyle: { fontWeight: '500' },
            cellStyle: { fontWeight: '400' }
        },
        {
            key: 'total',
            header: 'Total de Atendimentos',
            headerStyle: { fontWeight: '500', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => number.formatToBRNumber(value)
        }
    ];

    return (
        <div className="mapa-container-dashboards">
            <MapContainer
                center={center}
                zoom={4}
                className="leaflet-container-dashboards"
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {chartData.counterByCity.map((city, index) => (
                    <Marker
                        key={index}
                        position={[city.latitude, city.longitude]}
                        icon={
                            new L.Icon({
                                iconUrl:
                                    'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png',
                                shadowUrl:
                                    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png',
                                iconSize: [25, 41],
                                iconAnchor: [12, 41],
                                popupAnchor: [1, -34],
                                shadowSize: [41, 41]
                            })
                        }
                    >
                        <Popup>{city.description}</Popup>
                    </Marker>
                ))}
            </MapContainer>

            <TableComponent
                data={chartData.counterByCity}
                columns={tableColumns}
                title="Atendimentos por Unidade"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};

export default CityServices;
